import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";

Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.StandaloneHeaderHelpers = {
        ui: {
            standaloneContainer: '#standalone_header',
            brandLogo: '#brand_logo',
            brandImageLink: '#banner_image_link',
            instagramProfile: '#instagram_profile',
            twitterProfile: '#twitter_profile',
            pinterestProfile: '#pinterest_profile',
            facebookProfile: '#facebook_profile',
            socialIcons: '.social_profile_icons'
        },
        events: {
            'click @ui.brandLogo': 'trackAnalytics',
            'click @ui.brandImageLink': 'trackAnalytics',
            'click @ui.socialIcons': 'trackAnalytics'
        },
        initialize: function() {
            this.displayOptions = App.request('get:display:options');
            this.listenTo(this.displayOptions, {
                'change:standaloneOptions.bannerImage_showHide': this.render,
                'change:standaloneOptions.logoImage_showHide': this.render,
                'change:standaloneOptions.logoImage_backgroundImage': this.render,
                'change:standaloneOptions.bannerImage_backgroundImage': this.render,
                'change:standaloneOptions.logoImage_input': this.render,
                'change:standaloneOptions.bannerImage_input': this.render
            });
        },
        onShow: function() {
            var socialMedia = ['instagram', 'twitter', 'pinterest', 'facebook'];
            _.each(socialMedia, this.showSocialIcon.bind(this));
        },
        trackAnalytics: function(ev) {
            App.execute('standalone:click:through', $(ev.currentTarget).attr('id'));
        },
        showSocialIcon: function(platform) {
            var icon = platform + 'Profile';

            if (!_.isFalsy(this.displayOptions.get(platform + '_username'))) {
                this.ui[icon].css('display', 'inline-block');
            }
        },
        templateHelpers: function() {
            var _this = this;

            return {
                shouldShowBannerImage: function() {
                    return _this.displayOptions.get('standaloneOptions.bannerImage_showHide');
                },
                shouldShowLogoImage: function() {
                    return _this.displayOptions.get('standaloneOptions.logoImage_showHide');
                },
                isStandalone: function() {
                    return _this.displayOptions.get('channel') === 'standalone';
                },
                getLogoImage: function() {
                    if (!_.isFalsy(_this.displayOptions.get('standaloneOptions.logoImage_backgroundImage'))) {
                        return 'background-image: url(' + _this.displayOptions.get('standaloneOptions.logoImage_backgroundImage') + ')';
                    }
                    return '';
                },
                getLogoRedirectURL: function() {
                    return _this.displayOptions.get('standaloneOptions.logoImage_input') || '';
                },
                getBannerImage: function() {
                    if (!_.isFalsy(_this.displayOptions.get('standaloneOptions.bannerImage_backgroundImage'))) {
                        return 'background-image: url(' + _this.displayOptions.get('standaloneOptions.bannerImage_backgroundImage') + ')';
                    }

                    if (gon.previewMode) {
                        return '';
                    }

                    return 'display:none;';
                },
                getBannerImageURL: function() {
                    if (!_.isFalsy(_this.displayOptions.get('standaloneOptions.bannerImage_backgroundImage'))) {
                        return _this.displayOptions.get('standaloneOptions.bannerImage_backgroundImage');
                    }
                    return '';
                },
                getBannerRedirectURL: function() {
                    return _this.displayOptions.get('standaloneOptions.bannerImage_input') || '';
                },
                getInstagramURL: function() {
                    var user = _this.displayOptions.get('instagram_username');
                    if (!_.isFalsy(user) && !_.isFalsy(user.user_name)) {
                        return 'https://www.instagram.com/' + user.user_name;
                    }
                    return '';
                },
                getTwitterURL: function() {
                    var user = _this.displayOptions.get('twitter_username');
                    if (!_.isFalsy(user) && !_.isFalsy(user.user_name)) {
                        return 'https://www.twitter.com/' + user.user_name;
                    }
                    return '';
                },
                getPinterestURL: function() {
                    var user = _this.displayOptions.get('pinterest_username');
                    if (!_.isFalsy(user) && !_.isFalsy(user.user_name)) {
                        return 'https://www.pinterest.com/' + user.user_name;
                    }
                    return '';
                },
                getFacebookURL: function() {
                    var user = _this.displayOptions.get('facebook_username');
                    if (!_.isFalsy(user) && !_.isFalsy(user.social_id)) {
                        return 'https://www.facebook.com/' + user.social_id;
                    }
                    return '';
                },
                getLayoutClass: function() {
                    return _this.displayOptions.get('headerOptions').layout;
                },
                getButtonClass: function() {
                    return _this.displayOptions.get('headerOptions').button;
                },
                getHeaderTitle: function() {
                    return _this.displayOptions.get('headerOptions').showTitle ? _this.displayOptions.get('headerOptions').title : '';
                },
                showDescription: function() {
                    return _this.displayOptions.get('headerOptions').showDescription;
                },
                isDefaultHeaderDescription: function() {
                    // check if text saved in the Display Options matches the default English value
                    return _this.displayOptions.get('headerOptions').description === I18n.translations['en'].widget.header.description;
                },
                getHeaderDescription: function() {
                    return _this.displayOptions.get('headerOptions').description;
                },
                isTile: function() {
                    return _this.displayOptions.get('headerOptions').layout === 'tile';
                },
                getWidgetType: function() {
                    return _this.displayOptions.get('type');
                },
                isHeaderV2: function() {
                    var displayOpts = _this.displayOptions.get('headerOptions');
                    return !_.isFalsy(displayOpts) && Object.keys(displayOpts).length > 1;
                },
                isViewGallery: function() {
                    return !_.isFalsy(_this.displayOptions.get('headerOptions')) && _this.displayOptions.get('headerOptions').showViewGallery;
                },
                isDefaultViewGalleryText: function() {
                    // check if text saved in the Display Options matches the default English value
                    return _this.displayOptions.get('headerOptions').viewGalleryTitle === I18n.translations['en'].widget.header.view_gallery;
                },
                getViewGalleryText: function() {
                    return _this.displayOptions.get('headerOptions').viewGalleryTitle;
                },
                getViewGalleryUrl: function() {
                    return _this.displayOptions.get('headerOptions').viewGalleryUrl;
                },
                getHeaderBannerImage: function() {
                    return _this.displayOptions.get('headerOptions').bannerImage || '';
                },
                decode_utf8: decodeUtf8,
                hasTOS: App.hasTOS
            };
        }
    };
});
